import { render, staticRenderFns } from "./SuggestedQueries.vue?vue&type=template&id=d3337b20&scoped=true&"
import script from "./SuggestedQueries.vue?vue&type=script&lang=ts&"
export * from "./SuggestedQueries.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedQueries.vue?vue&type=style&index=0&id=d3337b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3337b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d3337b20', component.options)
    } else {
      api.reload('d3337b20', component.options)
    }
    module.hot.accept("./SuggestedQueries.vue?vue&type=template&id=d3337b20&scoped=true&", function () {
      api.rerender('d3337b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/SuggestedQueries.vue"
export default component.exports